(function() {
	const initFaqs = () => {
		const faqQuestions = document.querySelectorAll('.c-faqListItem__question');

		const handleQuestionClick = function(e) {
			e.preventDefault();

			const question = e.target;
			const faqItem = question.closest('.c-faqListItem');

			// Set/Remove active class on faq item
			if (faqItem) {
				faqItem.classList.toggle('is-active');
			}
		};

		if (faqQuestions && faqQuestions.length) {
			Array.from(faqQuestions).forEach(question => question.addEventListener('click', handleQuestionClick));
		}
	};

	document.addEventListener('DOMContentLoaded', initFaqs);
})();
